import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { useAuth } from '@/lib/auth'
import { companyLogoQueryOptions } from './company-logo'

/**
 * The sidebar mark: the company's logo when it has one and the bytes are
 * here, the product glyph otherwise — never an empty gap (FF-QA-020). The
 * query behind it is cached and retried (see company-logo.ts).
 */
export function CompanyLogo({ path, alt, className }: { path: string | null; alt: string; className?: string }) {
  const { authFetch } = useAuth()
  const logo = useQuery({ ...companyLogoQueryOptions(path ?? '', authFetch), enabled: path !== null })
  // A decoded-but-broken image (a corrupt upload) falls back too; keyed by
  // src so a later logo gets its own chance.
  const [brokenSrc, setBrokenSrc] = useState<string | undefined>(undefined)
  const src = path !== null ? logo.data : undefined
  if (!src || src === brokenSrc) return <span className="text-sidebar-primary" aria-hidden="true">▣</span>
  return <img src={src} alt={alt} className={className} onError={() => setBrokenSrc(src)} />
}
